import request from '@/utils/request'

export function getList(params) {
  return request({
    url: process.env.WEB_API + '/result/getList',
    method: 'post',
    data: params
  })
}

export function raceList(params) {
  return request({
    url: process.env.WEB_API + '/result/getRaceList',
    method: 'get',
    params
  })
}

export function getUserResultList (params) {
  return request({
    url: process.env.WEB_API + '/result/getUserResultList',
    method: 'post',
    data: params
  })
}

export function certificate(params) {
  return request({
    url: process.env.WEB_API + '/result/certificate',
    method: 'post',
    data: params,
    responseType: 'blob'
  })
}



// WEBPACK FOOTER //
// ./src/api/result.js